<div id="security">
  <div class="card">
    <div class="card-header border-bottom mb-1">
      <h2 class="card-title">
        {{ "SECURITY.EDIT_PASSWORD.TITLE" | translate }}
      </h2>
    </div>
    <div class="card-body">
      <form
        class="validate-form"
        [formGroup]="resetPasswordForm"
        (ngSubmit)="updatePassword()"
      >
        <div class="row">
          <div class="col-6">
            <div class="form-group">
              <label for="account-new-password">{{
                "SECURITY.EDIT_PASSWORD.NEW_PASSWORD" | translate
              }}</label>
              <div class="input-group form-password-toggle input-group-merge">
                <input
                  (input)="checkResetPasswordConditions()"
                  [type]="passwordTextTypeNew ? 'text' : 'password'"
                  id="account-new-password"
                  name="new-password"
                  formControlName="newPassword"
                  class="form-control"
                  [placeholder]="
                    'SECURITY.EDIT_PASSWORD.NEW_PASSWORD' | translate
                  "
                />
                <div class="input-group-append">
                  <span class="input-group-text cursor-pointer"
                    ><i
                      class="feather font-small-4"
                      [ngClass]="{
                        'icon-eye-off': passwordTextTypeNew,
                        'icon-eye': !passwordTextTypeNew
                      }"
                      (click)="togglePasswordTextTypeNew()"
                    ></i
                  ></span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="form-group">
              <label for="account-retype-new-password">{{
                "SECURITY.EDIT_PASSWORD.CONFIRM_PASSWORD" | translate
              }}</label>
              <div class="input-group form-password-toggle input-group-merge">
                <input
                  (input)="checkResetPasswordConditions()"
                  [type]="passwordTextTypeRetype ? 'text' : 'password'"
                  class="form-control"
                  formControlName="confirmPassword"
                  id="account-retype-new-password"
                  name="confirm-new-password"
                  [placeholder]="
                    'SECURITY.EDIT_PASSWORD.CONFIRM_PASSWORD' | translate
                  "
                />
                <!-- <div *ngIf="passwords"></div> -->
                <div class="input-group-append">
                  <span class="input-group-text cursor-pointer"
                    ><i
                      class="feather font-small-4"
                      [ngClass]="{
                        'icon-eye-off': passwordTextTypeRetype,
                        'icon-eye': !passwordTextTypeRetype
                      }"
                      (click)="togglePasswordTextTypeRetype()"
                    ></i
                  ></span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12">
            <div
              *ngIf="!passwordValid || !passwordMatch || passwordLongEnough"
              class="text-danger"
            >
              <small *ngIf="!passwordValid">{{
                "SECURITY.EDIT_PASSWORD.ERRORS.NO_VALID" | translate
              }}</small>
              <small *ngIf="!passwordMatch">{{
                "SECURITY.EDIT_PASSWORD.ERRORS.NO_MATCH" | translate
              }}</small>
              <small *ngIf="!passwordLongEnough">{{
                "SECURITY.EDIT_PASSWORD.ERRORS.MIN_STRING" | translate
              }}</small>
            </div>
            <button class="btn btn-primary mr-1 mt-1" rippleEffect>
              {{ "SECURITY.EDIT_PASSWORD.EDIT_BUTTON" | translate }}
            </button>
          </div>
        </div>
      </form>
      <!--/ form -->
    </div>
  </div>

  <div class="card">
    <div class="card-header border-bottom mb-1">
      <h2 class="card-title">
        {{ "SECURITY.TWO_STEPS_AUTH.TITLE" | translate }}
      </h2>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-12">
          <p class="font-weight-bolder">
            {{ "SECURITY.TWO_STEPS_AUTH.PROTECT" | translate }}
          </p>
          <div class="border-bottom">
            <p class="font-weight-bolder mb-0">SMS</p>
            <div class="d-flex justify-content-between">
              <p>+1(968) 819-2547</p>
              <div class="two-step-auth-icons">
                <a href="javascript:void(0)" class="text-secondary"
                  ><i class="h-100 w-auto mr-1" data-feather="edit"></i
                ></a>
                <a href="javascript:void(0)" class="text-secondary"
                  ><i class="h-100 w-auto" data-feather="trash"></i
                ></a>
              </div>
            </div>
          </div>
          <p class="mt-1 mb-0 pr-2">
            {{ "SECURITY.TWO_STEPS_AUTH.EXPLAIN" | translate }}
          </p>
        </div>
      </div>
    </div>
  </div>

  <div class="card">
    <div class="card-header border-bottom">
      <h2 class="card-title">
        {{ "SECURITY.RECENT_DEVICES.TITLE" | translate }}
      </h2>
    </div>
    <div class="card-body p-0">
      <ng-container *ngIf="lastConnections.length > 0; else noLastConnection">
        <div class="table-responsive">
          <table class="table">
            <thead class="thead-light">
              <tr>
                <th class="pl-2 border-top">
                  {{
                    "SECURITY.RECENT_DEVICES.TABLE.HEADERS.BROWSER" | translate
                  }}
                </th>
                <th class="pl-2 border-top">
                  {{ "SECURITY.RECENT_DEVICES.TABLE.HEADERS.DEVICE" | translate }}
                </th>
                <th class="pl-2 border-top">
                  {{
                    "SECURITY.RECENT_DEVICES.TABLE.HEADERS.LOCATION" | translate
                  }}
                </th>
                <th class="pl-2 border-top">
                  {{
                    "SECURITY.RECENT_DEVICES.TABLE.HEADERS.RECENT_ACTIVITY"
                      | translate
                  }}
                </th>
              </tr>
            </thead>
  
            <tbody>
              <tr *ngFor="let connection of lastConnections">
                <td class="pr-0 pl-2">
                  <img
                    [src]="browsersSrcs[connection.browser]"
                    class="mr-75"
                    height="20"
                    width="20"
                    alt="Angular"
                  />
                  <span class="font-weight-bold"
                    >{{ connection.browser }}
                    {{ "SECURITY.RECENT_DEVICES.TABLE.ROWS.TERM_ON" | translate }}
                    {{ connection.platform }}</span
                  >
                </td>
                <td class="pr-0 pl-2">{{ connection.device }}</td>
                <td class="pr-0 pt-0.75 pb-0 pl-2">
                  <span class="position-absolute mt-n1 custom-xs-text">{{
                    connection.country.toUpperCase()
                  }}</span>
                  {{ connection.zip }}
                </td>
                <td class="pr-0 pl-2">
                  {{ connection.created_at | date: "medium" }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </ng-container>
      <ng-template #noLastConnection>
        <p class="ml-1">{{ "SECURITY.RECENT_DEVICES.NO_LAST_CONNECTION" | translate }}</p>
      </ng-template>
    </div>
  </div>
</div>
